<template>
  <section class="small-12 medium-12 large-6 columns">
    <h1 v-html="vueModel.ContentViewModel.Step2Accident.StepTitle" />

    <article>
      <h3 v-html="vueModel.ContentViewModel.Step2Accident.ErrorMessageClaimEventDescription" />

      <div class="control">
        <Field
          as="textarea"
          v-model="vueModel.CreateClaimEntity.ClaimEventDescription"
          rules="required"
          cols="30"
          rows="3"
          name="describe-incident"
          :label="vueModel.ContentViewModel.Step2Accident.ErrorMessageClaimEventDescription"
        />
        <ValidationError name="describe-incident" />
      </div>

      <h3
        data-test-upload-photo-title
        v-html="vueModel.ContentViewModel.GeneralContent.TitleAttachPhotos"
      />

      <p
        data-test-upload-photo-text
        v-html="vueModel.ContentViewModel.GeneralContent.TextAttachPhotos"
      />

      <upload
        v-model="vueModel.files"
        :content="vueModel.ContentViewModel.Step4Shared"
        :title="vueModel.ContentViewModel.GeneralContent.SubtitleAttachPhotos"
      />
    </article>

    <!------------- Questionnaire ------------------------------------------------------------------------>
    <article v-if="hasQuestionnaireQuestions">
      <!--<h3>Vælg skadetype for indboskade</h3>-->

      <questionnaire :options="questions" />
    </article>

    <!------------- Er skaden anmeldt til politiet? ------------------------------------------------------>
    <article v-if="stepModel.ProductSpecific.AskForPoliceReportFiled" id="police-report-filed">
      <h3 v-html="vueModel.ContentViewModel.Step2Accident.TitlePoliceReport" />

      <div class="control">
        <Field
          name="police-report-filed"
          v-slot="{ field, meta }"
          :rules="{ required: stepModel.ProductSpecific.PoliceReportFiled === null }"
          v-model="stepModel.ProductSpecific.PoliceReportFiled"
        >
          <RadioGroupStacked
            v-bind="field"
            :options="stepModel.ProductSpecific.PoliceReportFiledOptions"
            :model-value="stepModel.ProductSpecific.PoliceReportFiled"
          />

          <ValidationError
            :name="field.name"
            :overrides="{
              required: vueModel.ContentViewModel.Step2Accident.ErrorMessagePoliceReport
            }"
            v-if="meta.validated && !meta.valid"
          />
        </Field>
      </div>

      <div
        v-if="
          stepModel.ProductSpecific.PoliceReportFiled &&
            stepModel.ProductSpecific.AskForPoliceInformation
        "
      >
        <police-information
          v-model="vueModel.CreateClaimEntity.ProductSpecific.PoliceInformation"
          :content-model="vueModel.ContentViewModel.Step2Accident"
          :required="stepModel.ProductSpecific.PoliceReportFiled"
          :claim-event-date="vueModel.CreateClaimStep1Model.ClaimEventDate"
        >
          <template #tooltip1>
            <span
              v-html="vueModel.ContentViewModel.Step2Accident.LabelAndTooltipPoliceReportWhen"
            />
          </template>
          <template #tooltip2>
            <span
              v-html="
                vueModel.ContentViewModel.Step2Accident.LabelAndTooltipPoliceReportJournalNumber
              "
            />
          </template>
          <template #tooltip3>
            <span
              v-html="vueModel.ContentViewModel.Step2Accident.LabelAndTooltipPoliceReportDistrict"
            />
          </template>
        </police-information>
      </div>
    </article>
  </section>
</template>

<script>
import ValidationError from '@/components/UI/ValidationError.vue';
import Upload from '../../components/Upload.vue';
import ReportClaimMixin from '@/components/Feature/Claims/flows/ReportClaimMixin.vue';
import ReportClaimServicesMixin from '@/components/Feature/Claims/flows/ReportClaimServicesMixin.vue';

export default {
  name: 'ReportClaimAccidentStep2',
  components: { ValidationError, Upload },
  mixins: [ReportClaimMixin, ReportClaimServicesMixin],
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      stepModel: this.vueModel.CreateClaimStep2Model
    };
  }
};
</script>
